import React, {
    useEffect,
    useRef
}
from "react";

import * as am4core
from "@amcharts/amcharts4/core";

import * as am4charts
from "@amcharts/amcharts4/charts";

import {
    LICENCE_KEY
}
from "../../../constants/charts";


am4core.addLicense(
    LICENCE_KEY);


export default function CostImpactAnalysis({
    id,
    title = "COST VS IMPACT ANALYSIS",
    clickFunction
})
{
    const chartRef =
        useRef(null);


    useEffect(() =>
    {
        const chart =
            am4core.create(
                id,
                am4charts.XYChart);

        chartRef.current =
            chart;


        /*
         * Demo data
         *
         * cost:
         *      0 - 100
         *
         * impact:
         *      0 - 100
         *
         * buildingsAffected:
         *      controls bubble size
         */

        chart.data =
        [
            {
                id: 1,
                title: "Fire Door Programme",
                category: "Safety",
                severity: "CRITICAL",

                cost: 72,
                impact: 82,

                buildingsAffected: 18,

                description:
                    "Overdue inspections and remedial works across multiple buildings.",

                colour:
                    "#ef4444"
            },
            {
                id: 2,
                title: "Legionella Testing",
                category: "Compliance",
                severity: "HIGH",

                cost: 26,
                impact: 68,

                buildingsAffected: 9,

                description:
                    "Outstanding water hygiene sampling and risk assessment actions.",

                colour:
                    "#f97316"
            },
            {
                id: 3,
                title: "HVAC Upgrade",
                category: "Assets",
                severity: "HIGH",

                cost: 66,
                impact: 46,

                buildingsAffected: 12,

                description:
                    "Targeted plant upgrades to improve reliability and energy performance.",

                colour:
                    "#f97316"
            },
            {
                id: 4,
                title: "Emergency Lighting",
                category: "Compliance",
                severity: "MEDIUM",

                cost: 17,
                impact: 20,

                buildingsAffected: 6,

                description:
                    "Replacement and testing programme for failed emergency lighting.",

                colour:
                    "#fbbf24"
            },
            {
                id: 5,
                title: "Lift Modernisation",
                category: "Assets",
                severity: "LOW",

                cost: 61,
                impact: 20,

                buildingsAffected: 8,

                description:
                    "Planned lift control and component modernisation programme.",

                colour:
                    "#4caf50"
            }
        ];


        /*
         * General chart spacing
         */

        chart.paddingTop =
            8;

        chart.paddingRight =
            18;

        chart.paddingBottom =
            2;

        chart.paddingLeft =
            4;


        /*
         * Cursor
         */

        const cursor =
            new am4charts.XYCursor();

        cursor.behavior =
            "none";

        cursor.lineX.stroke =
            am4core.color(
                "#94a3b8");

        cursor.lineX.strokeOpacity =
            0.35;

        cursor.lineX.strokeDasharray =
            "3,3";

        cursor.lineY.stroke =
            am4core.color(
                "#94a3b8");

        cursor.lineY.strokeOpacity =
            0.35;

        cursor.lineY.strokeDasharray =
            "3,3";

        chart.cursor =
            cursor;


        /*
         * X axis - Cost
         */

        const costAxis =
            chart.xAxes.push(
                new am4charts.ValueAxis());

        costAxis.min =
            0;

        costAxis.max =
            100;

        costAxis.strictMinMax =
            true;

        costAxis.renderer.minGridDistance =
            60;

        costAxis.renderer.grid.template.stroke =
            am4core.color(
                "#d9dee7");

        costAxis.renderer.grid.template.strokeOpacity =
            0.45;

        costAxis.renderer.grid.template.strokeDasharray =
            "2,2";

        costAxis.renderer.baseGrid.stroke =
            am4core.color(
                "#667085");

        costAxis.renderer.baseGrid.strokeOpacity =
            0.8;

        costAxis.renderer.baseGrid.strokeWidth =
            1.2;

        costAxis.renderer.labels.template.fill =
            am4core.color(
                "#5d6675");

        costAxis.renderer.labels.template.fontSize =
            11;

        costAxis.renderer.labels.template.paddingTop =
            8;


        /*
         * Convert numeric axis values into
         * Low / Medium / High labels
         */

        costAxis.renderer.labels.template.adapter.add(
            "text",
            (
                text,
                target
            ) =>
            {
                if (
                    !target.dataItem
                    ||
                    target.dataItem.value === undefined
                )
                {
                    return "";
                }

                const value =
                    target.dataItem.value;

                if (
                    value === 0
                )
                {
                    return "Low";
                }

                if (
                    value === 50
                )
                {
                    return "Medium";
                }

                if (
                    value === 100
                )
                {
                    return "High";
                }

                return "";
            });


        /*
         * X axis title
         */

        costAxis.title.text =
            "COST";

        costAxis.title.fill =
            am4core.color(
                "#303846");

        costAxis.title.fontSize =
            11;

        costAxis.title.fontWeight =
            "600";

        costAxis.title.paddingTop =
            8;


        /*
         * Y axis - Impact
         */

        const impactAxis =
            chart.yAxes.push(
                new am4charts.ValueAxis());

        impactAxis.min =
            0;

        impactAxis.max =
            100;

        impactAxis.strictMinMax =
            true;

        impactAxis.renderer.minGridDistance =
            45;

        impactAxis.renderer.grid.template.stroke =
            am4core.color(
                "#d9dee7");

        impactAxis.renderer.grid.template.strokeOpacity =
            0.45;

        impactAxis.renderer.grid.template.strokeDasharray =
            "2,2";

        impactAxis.renderer.baseGrid.stroke =
            am4core.color(
                "#667085");

        impactAxis.renderer.baseGrid.strokeOpacity =
            0.8;

        impactAxis.renderer.baseGrid.strokeWidth =
            1.2;

        impactAxis.renderer.labels.template.fill =
            am4core.color(
                "#5d6675");

        impactAxis.renderer.labels.template.fontSize =
            11;

        impactAxis.renderer.labels.template.paddingRight =
            8;


        impactAxis.renderer.labels.template.adapter.add(
            "text",
            (
                text,
                target
            ) =>
            {
                if (
                    !target.dataItem
                    ||
                    target.dataItem.value === undefined
                )
                {
                    return "";
                }

                const value =
                    target.dataItem.value;

                if (
                    value === 0
                )
                {
                    return "Low";
                }

                if (
                    value === 50
                )
                {
                    return "Medium";
                }

                if (
                    value === 100
                )
                {
                    return "High";
                }

                return "";
            });


        /*
         * Y axis title
         */

        impactAxis.title.text =
            "IMPACT";

        impactAxis.title.fill =
            am4core.color(
                "#303846");

        impactAxis.title.fontSize =
            11;

        impactAxis.title.fontWeight =
            "600";

        impactAxis.title.rotation =
            0;

        impactAxis.title.align =
            "center";

        impactAxis.title.valign =
            "top";

        impactAxis.title.paddingBottom =
            8;


        /*
         * Additional guide lines at
         * Low / Medium / High boundaries
         */

        const costMediumRange =
            costAxis.axisRanges.create();

        costMediumRange.value =
            50;

        costMediumRange.grid.stroke =
            am4core.color(
                "#b8c0cc");

        costMediumRange.grid.strokeOpacity =
            0.7;

        costMediumRange.grid.strokeDasharray =
            "4,4";


        const impactMediumRange =
            impactAxis.axisRanges.create();

        impactMediumRange.value =
            50;

        impactMediumRange.grid.stroke =
            am4core.color(
                "#b8c0cc");

        impactMediumRange.grid.strokeOpacity =
            0.7;

        impactMediumRange.grid.strokeDasharray =
            "4,4";


        /*
         * Bubble series
         */

        const series =
            chart.series.push(
                new am4charts.LineSeries());

        series.dataFields.valueX =
            "cost";

        series.dataFields.valueY =
            "impact";

        series.strokeOpacity =
            0;

        series.fillOpacity =
            0;

        series.connect =
            false;

        series.sequencedInterpolation =
            true;

        series.sequencedInterpolationDelay =
            90;

        series.hiddenState.properties.opacity =
            0;


        /*
         * Bubble
         */

        const bullet =
            series.bullets.push(
                new am4charts.CircleBullet());

        bullet.circle.radius =
            10;

        bullet.circle.stroke =
            am4core.color(
                "#ffffff");

        bullet.circle.strokeWidth =
            2;

        bullet.circle.fillOpacity =
            0.93;

        bullet.circle.cursorOverStyle =
            am4core.MouseCursorStyle.pointer;


        /*
         * Bubble size is based on
         * buildingsAffected.
         *
         * Minimum radius = 9
         * Maximum radius = 23
         */

        bullet.circle.adapter.add(
            "radius",
            (
                radius,
                target
            ) =>
            {
                const data =
                    target.dataItem
                    &&
                    target.dataItem.dataContext;

                if (
                    !data
                )
                {
                    return 10;
                }

                const buildingsAffected =
                    Number(
                        data.buildingsAffected)
                    || 1;

                return Math.max(
                    9,
                    Math.min(
                        23,
                        7
                        +
                        Math.sqrt(
                            buildingsAffected)
                        *
                        3.6
                    )
                );
            });


        /*
         * Bubble colour is taken from
         * each data item
         */

        bullet.circle.adapter.add(
            "fill",
            (
                fill,
                target
            ) =>
            {
                const data =
                    target.dataItem
                    &&
                    target.dataItem.dataContext;

                if (
                    data
                    &&
                    data.colour
                )
                {
                    return am4core.color(
                        data.colour);
                }

                return fill;
            });


        bullet.circle.adapter.add(
            "stroke",
            (
                stroke,
                target
            ) =>
            {
                const data =
                    target.dataItem
                    &&
                    target.dataItem.dataContext;

                if (
                    data
                    &&
                    data.colour
                )
                {
                    return am4core.color(
                        data.colour);
                }

                return stroke;
            });


        /*
         * Subtle bubble shadow
         */

        const shadow =
            new am4core.DropShadowFilter();

        shadow.blur =
            5;

        shadow.opacity =
            0.20;

        shadow.dx =
            0;

        shadow.dy =
            2;

        bullet.circle.filters.push(
            shadow);


        /*
         * Bubble hover state
         */

        const hoverState =
            bullet.circle.states.create(
                "hover");

        hoverState.properties.scale =
            1.13;

        hoverState.properties.fillOpacity =
            1;

        hoverState.properties.strokeWidth =
            3;


        /*
         * Tooltip
         */
		
		

        bullet.tooltipText =
            "[font-size:13px][bold]{title}[/][/]\n"
            +
            "[font-size:11px]{category} · {severity}[/]\n\n"
            +
            "[font-size:11px]Cost: [bold]{valueX.formatNumber('#')} / 100[/]\n"
            +
            "Impact: [bold]{valueY.formatNumber('#')} / 100[/]\n"
            +
            "Buildings affected: [bold]{buildingsAffected}[/][/]\n\n"
            +
            "[font-size:11px]{description}[/]";

     

        /*
         * Click event
         */

        bullet.events.on(
            "hit",
            event =>
            {
                const data =
                    event.target.dataItem
                    &&
                    event.target.dataItem.dataContext;

                if (
                    clickFunction
                    &&
                    data
                )
                {
                    clickFunction(
                        data);
                }
            });


        /*
         * Bubble labels
         */

        const labelBullet =
            series.bullets.push(
                new am4charts.LabelBullet());

        labelBullet.label.text =
            "{title}";

        labelBullet.label.fill =
            am4core.color(
                "#303846");

        labelBullet.label.fontSize =
            10;

        labelBullet.label.fontWeight =
            "500";

        labelBullet.label.horizontalCenter =
            "left";

        labelBullet.label.verticalCenter =
            "middle";

        labelBullet.label.dx =
            17;

        labelBullet.label.maxWidth =
            120;

        labelBullet.label.wrap =
            true;


        /*
         * Move labels further away from
         * larger bubbles
         */

        labelBullet.label.adapter.add(
            "dx",
            (
                dx,
                target
            ) =>
            {
                const data =
                    target.dataItem
                    &&
                    target.dataItem.dataContext;

                if (
                    !data
                )
                {
                    return 17;
                }

                const buildingsAffected =
                    Number(
                        data.buildingsAffected)
                    || 1;

                const radius =
                    Math.max(
                        9,
                        Math.min(
                            23,
                            7
                            +
                            Math.sqrt(
                                buildingsAffected)
                            *
                            3.6
                        )
                    );

                return radius + 7;
            });


        /*
         * Severity legend
         */

        chart.legend =
            new am4charts.Legend();

        chart.legend.position =
            "right";

        chart.legend.valign =
            "top";

        chart.legend.marginTop =
            0;

        chart.legend.marginLeft =
            10;

        chart.legend.paddingTop =
            4;

        chart.legend.paddingRight =
            0;

        chart.legend.paddingBottom =
            0;

        chart.legend.paddingLeft =
            0;

        chart.legend.labels.template.fill =
            am4core.color(
                "#4b5563");

        chart.legend.labels.template.fontSize =
            11;

        chart.legend.valueLabels.template.disabled =
            true;

        chart.legend.itemContainers.template.paddingTop =
            3;

        chart.legend.itemContainers.template.paddingBottom =
            3;

        chart.legend.itemContainers.template.clickable =
            false;

        chart.legend.itemContainers.template.focusable =
            false;

        chart.legend.markers.template.width =
            10;

        chart.legend.markers.template.height =
            10;


        /*
         * Manual legend entries because
         * all bubbles use one chart series
         */

        chart.legend.data =
        [
            {
                name: "Critical",
                fill:
                    am4core.color(
                        "#ef4444")
            },
            {
                name: "High",
                fill:
                    am4core.color(
                        "#f97316")
            },
            {
                name: "Medium",
                fill:
                    am4core.color(
                        "#fbbf24")
            },
            {
                name: "Low",
                fill:
                    am4core.color(
                        "#4caf50")
            }
        ];


        chart.legend.markers.template.children
            .getIndex(
                0)
            .cornerRadius(
                10,
                10,
                10,
                10);


        /*
         * Bubble size key
         */

        const sizeKey =
            chart.chartContainer.createChild(
                am4core.Container);

        sizeKey.layout =
            "vertical";

        sizeKey.isMeasured =
            false;

        sizeKey.align =
            "right";

        sizeKey.valign =
            "bottom";

        sizeKey.marginRight =
            4;

        sizeKey.marginBottom =
            6;


        const sizeTitle =
            sizeKey.createChild(
                am4core.Label);

        sizeTitle.text =
            "Bubble size =";

        sizeTitle.fontSize =
            10;

        sizeTitle.fill =
            am4core.color(
                "#667085");

        sizeTitle.marginBottom =
            1;


        const sizeSubtitle =
            sizeKey.createChild(
                am4core.Label);

        sizeSubtitle.text =
            "Buildings affected";

        sizeSubtitle.fontSize =
            10;

        sizeSubtitle.fontWeight =
            "500";

        sizeSubtitle.fill =
            am4core.color(
                "#303846");


        /*
         * Initial animation
         */

        series.appear(
            800);

        chart.appear(
            800,
            100);


        /*
         * Cleanup
         */

        return () =>
        {
            if (
                chartRef.current
            )
            {
                chartRef.current.dispose();

                chartRef.current =
                    null;
            }
        };

    }, [
        id,
        clickFunction
    ]);


    return (
        <div
            style={{
                width: "100%",
                height: "100%",

                display: "flex",
                flexDirection: "column",

                background:
                    "transparent",

                overflow:
                    "hidden"
            }}
        >
		<div
		               style={{
		                   fontSize: "12px",
		                   fontWeight: 500,

		                   textTransform: "uppercase",

		                   marginBottom: "16px",

		                   color: "#222"
		               }}
		           >
                {title}
            </div>

            <div
                id={id}

                style={{
                    width:
                        "100%",

                    flex:
                        1,

                    minHeight:
                        0
                }}
            />
        </div>
    );
}